import { ChangeDetectionStrategy, Component } from '@angular/core'
import { NoticeSessionChatFloatingService } from './notice-session-chat-floating.service'

@Component({
	selector: 'app-notice-session-chat-floating-host',
	templateUrl: './notice-session-chat-floating-host.component.html',
	styleUrls: ['./notice-session-chat-floating-host.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NoticeSessionChatFloatingHostComponent {
	readonly state$ = this.floatingService.state$

	constructor(private floatingService: NoticeSessionChatFloatingService) {}
}
